var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterInOrderAscIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3869_84841)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H1V15H16V16H0V0ZM10 3.5C10 3.36739 10.0527 3.24021 10.1464 3.14645C10.2402 3.05268 10.3674 3 10.5 3H14.5C14.6326 3 14.7598 3.05268 14.8536 3.14645C14.9473 3.24021 15 3.36739 15 3.5V7.5C15 7.63261 14.9473 7.75979 14.8536 7.85355C14.7598 7.94732 14.6326 8 14.5 8C14.3674 8 14.2402 7.94732 14.1464 7.85355C14.0527 7.75979 14 7.63261 14 7.5V4.9L10.387 9.317C10.3428 9.37099 10.2877 9.41511 10.2254 9.44655C10.1631 9.47798 10.0949 9.49602 10.0252 9.4995C9.9555 9.50299 9.88584 9.49184 9.8207 9.46678C9.75556 9.44172 9.69639 9.4033 9.647 9.354L7.06 6.767L3.404 11.794C3.32402 11.8957 3.20774 11.9624 3.07958 11.9802C2.95143 11.9979 2.82138 11.9653 2.71677 11.8892C2.61216 11.8131 2.54113 11.6994 2.51861 11.572C2.49609 11.4446 2.52383 11.3134 2.596 11.206L6.596 5.706C6.63846 5.64751 6.69309 5.59893 6.75613 5.56359C6.81917 5.52825 6.88912 5.50699 6.96117 5.50129C7.03322 5.49559 7.10564 5.50557 7.17346 5.53055C7.24128 5.55554 7.30287 5.59492 7.354 5.646L9.963 8.256L13.445 4H10.5C10.3674 4 10.2402 3.94732 10.1464 3.85355C10.0527 3.75979 10 3.63261 10 3.5Z",
    fill: "#242424"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3869_84841"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterInOrderAscIcon);
export default __webpack_public_path__ + "static/media/filter-in_order-asc-icon.ce4c97dd6cf5eec48948c05fc0d9738a.svg";
export { ForwardRef as ReactComponent };